import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-home",
  templateUrl: "./home.html",
  styleUrls: ["./home.css"],
  standalone: false,
})
export class Home implements OnInit {
  constructor() {}

  ngOnInit() {
    console.log("init home");
  }
}
